import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { MyTickets } from '../../components/MyTickets/MyTickets';
import { useTicketing } from '../../contexts/TicketingContext';
import { useTheme } from '../../contexts/ThemeContext';
import './MyTicketsView.css';

export function MyTicketsView() {
  const { theme } = useTheme();
  const navigate = useNavigate();
  const {
    tickets,
    techs,
    currentUserId,
    handleStartTicket,
    handleHoldTicket,
    handleCompleteTicket,
    handleReopenTicket,
    handleReassignTicket,
    handleChangePriority,
  } = useTicketing();

  const handleOpenFullView = useCallback((ticketId: string) => {
    navigate(`/ticketing/ticket/${ticketId}`);
  }, [navigate]);

  return (
    <div className="my-tickets-view" data-theme={theme}>
      <div className="my-tickets-view__container">
        <MyTickets
          tickets={tickets}
          techs={techs}
          currentUserId={currentUserId}
          onStart={handleStartTicket}
          onHold={handleHoldTicket}
          onComplete={handleCompleteTicket}
          onReopen={handleReopenTicket}
          onReassign={handleReassignTicket}
          onChangePriority={handleChangePriority}
          onOpenFullView={handleOpenFullView}
        />
      </div>
    </div>
  );
}
